import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { en } from '@/assets/locales/en.ts';
import { I18N_NAMESPACE, pl } from '@/assets/locales/pl.ts';

const resources = {
  en,
  pl,
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: I18N_NAMESPACE,
    detection: {
      caches: ['localStorage', 'cookie'],
      order: ['localStorage', 'cookie', 'navigator'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: [I18N_NAMESPACE],
    resources,
  });
